import { Button } from "../../../components/ui/button";
import {
  SECTION_FILTER_ACTIVE_CLS,
  SECTION_FILTER_INACTIVE_CLS,
} from "./utilities/constants";

export interface SectionFilterChipProps {
  active: boolean;
  label: string;
  mono?: boolean;
  onClick: () => void;
}

export function SectionFilterChip({
  active,
  label,
  mono,
  onClick,
}: SectionFilterChipProps) {
  const toneCls = active ? SECTION_FILTER_ACTIVE_CLS : SECTION_FILTER_INACTIVE_CLS;
  const fontCls = mono ? "font-mono" : "font-medium";

  return (
    <Button
      type="button"
      variant="outline"
      size="none"
      onClick={onClick}
      aria-pressed={active}
      className={`h-auto rounded-md border px-2 py-1 text-[11px] ${fontCls} transition-colors ${toneCls}`}
    >
      {label}
    </Button>
  );
}
